<template>
   <div id="app">
      <router-view />
      <PageFooter :homepage="isHomePage" />
   </div>
</template>

<script>
import PageFooter from '@/components/PageFooter';

// used by autocomplete
import 'jquery-ui-bundle';
import 'jquery-ui-bundle/jquery-ui.min.css';

export default {
   name: 'App',
   components: {
      PageFooter,
   },

   computed: {
      isHomePage() {
         return this.$route.path === '/';
      },
   },
};
</script>

<style>
#app {
   /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   /* text-align: center;
   color: #2c3e50;
   margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue